// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
   background-color: #f5f5f5;
   width: 600px;
   min-width: 600px;
   max-width: 600px;
   overflow-y: auto;
   max-height: 400px;
   min-height: 400px;
}

ul.doclist {
   list-style: none;
   margin: 9px 0 0;
   padding: 0;
}
ul.doclist li {
   padding: 5px 10px;
}
ul.doclist a {
   cursor: pointer;
   color: #666;
}
ul.doclist a.selectedRoot {
   color: #00bed6;
}

.mat-dialog-content {
   overflow: hidden;
}
.mat-dialog-title {
   font-size: 18px;
   word-break: break-all;
   width: 600px;
}

img {
   width: 20px;
   height: 20px;
   vertical-align: top;
   margin-right: 5px;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}

.displayNone {
   display: none;
}

.on-loading {
   display: flex;
   justify-content: center;
}

a.denied {
   cursor: default;
   color: #a7a6a6;
   text-decoration: none;
}

.denied img {
   filter: grayscale(100%);
   opacity: .8;
}

.text-overflow {
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   max-width: 40%;
}

i:not(.caret):before {
   vertical-align: middle;
}
  
i.caret {
   cursor: default;
   font-size: inherit;
   left: 0;
   transition: transform .4s;
}

.expanded {
   transform: rotate(90deg);
}

.doclist a.denied {
   cursor: default;
   color: #a7a6a6;
   text-decoration: none;
}

.doclist {
   list-style: none;
   margin: 9px 0 0;
   padding: 0;
}

.doclist li {
   padding: 5px 10px;
}

.doclist a {
   cursor: pointer;
}

.doclist a.selectedPath {
   color: #00bed6;
}

.doclist i {
   width: 20px;
   height: 20px;
   line-height: 20px;
   text-align: center;
}

app-google-drive-folders {
   display: block;
   margin-left: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/google-drive-move-dialog/google-drive-move-dialog.component.css"],"names":[],"mappings":"AAAA;GACG,yBAAyB;GACzB,YAAY;GACZ,gBAAgB;GAChB,gBAAgB;GAChB,gBAAgB;GAChB,iBAAiB;GACjB,iBAAiB;AACpB;;AAEA;GACG,gBAAgB;GAChB,eAAe;GACf,UAAU;AACb;AACA;GACG,iBAAiB;AACpB;AACA;GACG,eAAe;GACf,WAAW;AACd;AACA;GACG,cAAc;AACjB;;AAEA;GACG,gBAAgB;AACnB;AACA;GACG,eAAe;GACf,qBAAqB;GACrB,YAAY;AACf;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,mBAAmB;GACnB,iBAAiB;AACpB;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,aAAa;GACb,uBAAuB;AAC1B;;AAEA;GACG,eAAe;GACf,cAAc;GACd,qBAAqB;AACxB;;AAEA;GACG,uBAAuB;GACvB,WAAW;AACd;;AAEA;GACG,mBAAmB;GACnB,gBAAgB;GAChB,uBAAuB;GACvB,cAAc;AACjB;;AAEA;GACG,sBAAsB;AACzB;;AAEA;GACG,eAAe;GACf,kBAAkB;GAClB,OAAO;GACP,yBAAyB;AAC5B;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,eAAe;GACf,cAAc;GACd,qBAAqB;AACxB;;AAEA;GACG,gBAAgB;GAChB,eAAe;GACf,UAAU;AACb;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,iBAAiB;GACjB,kBAAkB;AACrB;;AAEA;GACG,cAAc;GACd,iBAAiB;AACpB","sourcesContent":[".main {\n   background-color: #f5f5f5;\n   width: 600px;\n   min-width: 600px;\n   max-width: 600px;\n   overflow-y: auto;\n   max-height: 400px;\n   min-height: 400px;\n}\n\nul.doclist {\n   list-style: none;\n   margin: 9px 0 0;\n   padding: 0;\n}\nul.doclist li {\n   padding: 5px 10px;\n}\nul.doclist a {\n   cursor: pointer;\n   color: #666;\n}\nul.doclist a.selectedRoot {\n   color: #00bed6;\n}\n\n.mat-dialog-content {\n   overflow: hidden;\n}\n.mat-dialog-title {\n   font-size: 18px;\n   word-break: break-all;\n   width: 600px;\n}\n\nimg {\n   width: 20px;\n   height: 20px;\n   vertical-align: top;\n   margin-right: 5px;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n\n.displayNone {\n   display: none;\n}\n\n.on-loading {\n   display: flex;\n   justify-content: center;\n}\n\na.denied {\n   cursor: default;\n   color: #a7a6a6;\n   text-decoration: none;\n}\n\n.denied img {\n   filter: grayscale(100%);\n   opacity: .8;\n}\n\n.text-overflow {\n   white-space: nowrap;\n   overflow: hidden;\n   text-overflow: ellipsis;\n   max-width: 40%;\n}\n\ni:not(.caret):before {\n   vertical-align: middle;\n}\n  \ni.caret {\n   cursor: default;\n   font-size: inherit;\n   left: 0;\n   transition: transform .4s;\n}\n\n.expanded {\n   transform: rotate(90deg);\n}\n\n.doclist a.denied {\n   cursor: default;\n   color: #a7a6a6;\n   text-decoration: none;\n}\n\n.doclist {\n   list-style: none;\n   margin: 9px 0 0;\n   padding: 0;\n}\n\n.doclist li {\n   padding: 5px 10px;\n}\n\n.doclist a {\n   cursor: pointer;\n}\n\n.doclist a.selectedPath {\n   color: #00bed6;\n}\n\n.doclist i {\n   width: 20px;\n   height: 20px;\n   line-height: 20px;\n   text-align: center;\n}\n\napp-google-drive-folders {\n   display: block;\n   margin-left: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
